import { defineComponent as _defineComponent } from 'vue'
import { shallowRef, computed, ref, watch, onMounted } from 'vue'
import { useMediaControls } from '@vueuse/core'

import { ParagraphItem } from './type'
import ContentMain from './components/ContentMain.vue'
import OverflowTooltip from '@/components/OverflowTooltip/index.vue'
import { Message } from 'element-ui'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    ttsPropertyName: null,
    title: null,
    paragraphList: null,
    urlLink: null,
    type: null,
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  ttsPropertyName?: string;
  title: string;
  paragraphList: ParagraphItem[];
  urlLink: string;
  type: 'tts' | 'asr';
  loading?: boolean
}



onMounted(() => {
  handleSetSliderListener()
})

// 拖动完成进度条后是否需要播放
let needPlay = false
// 拦截拖动进度条进行播放相关操作
function handleSetSliderListener() {
  const audioBar = document.querySelector('.audio-bar--line')
  const sliderHandle = audioBar?.querySelector('.el-slider__button-wrapper')
  sliderHandle?.addEventListener('mousedown', () => {
    needPlay = playing.value
    pause()
  })
  sliderHandle?.addEventListener('mouseup', () => {
    needPlay && play()
  })
}

// const configRate = [
//   {
//     label: 'x1',
//     value: 1
//   },
//   {
//     label: 'x1.5',
//     value: 1.5
//   },
//   {
//     label: 'x2',
//     value: 2
//   }
// ]
const audioRef = shallowRef<HTMLAudioElement>()
onMounted(() => {
  audioRef.value?.addEventListener('error', () => {
    Message.error('音频资源加载失败')
  }, true)
})
const audioSrc = ref('')
watch(() => props.urlLink, v => {
  if (v) {
    audioSrc.value = v
  }
}, { immediate: true })

const { playing, currentTime, duration } = useMediaControls(audioRef, {
  src: audioSrc
})

function play() {
  console.log('play')
  playing.value = true
}
function pause() {
  console.log('pause')
  playing.value = false
}
// 格式化时间
function formatSeconds (value: number) {
  if (!value) {
    return `${'00'}:${'00'}:${'00'}`
  } else {
    const result = value
    const h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
    const m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60))
    const s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60))
    return `${h}:${m}:${s}`
  }
}

const currentTimeShow = computed(() => {
  return formatSeconds(currentTime.value)
})
const durationTimeShow = computed(() => {
  return formatSeconds(duration.value)
})

// 根据当前播放位置计算是否需要高亮
const curSentence = computed<[number, number]>(() => {
  let pIndex = 0 // 当前段下标
  let sIndex = 0 // 当前句下标
  // 音频可能没有加载出来
  if(currentTime.value !== 0) {
    //情况1. 最后一句的结束时间小于当前播放时间，高亮最后一片
    const lastSentence = props.paragraphList[props.paragraphList.length - 1].sentenceList
    const lastSentenceEndTime = lastSentence[lastSentence.length - 1].endTime
    if(currentTime.value * 1000 > lastSentenceEndTime){
      pIndex = props.paragraphList.length - 1
      sIndex = lastSentence.length - 1
    } else {
      paragraphLoop:
      for(let p = 0; p < props.paragraphList.length; p++) {
        const sentenceList = props.paragraphList[p].sentenceList
        for(let s = 0; s < sentenceList.length; s++) {
          const targetSentence = sentenceList[s]
          // 情况2. 如果当前句的开始时间已经大于了当前播放时间，返回前一句（引擎返回的时间有时候不是连续的）
          if(targetSentence.startTime > currentTime.value * 1000) {
            // 段落第一句已经超过了播放时间，返回前一段的最后一句（如果已经是第一段第一句，就高亮第一句就行）
            if(s === 0) {
              // 是否是第一段
              const isFirstParagraph = p - 1 < 0
              const preParagraphIdx = !isFirstParagraph ? p - 1 : 0
              const preSentenceList = props.paragraphList[preParagraphIdx].sentenceList
              pIndex = preParagraphIdx
              // 如果是第一段，就高亮第一句就行
              sIndex = !isFirstParagraph ? preSentenceList.length - 1 : 0
              break paragraphLoop
            } else {
              pIndex = p
              sIndex = s - 1
              break paragraphLoop
            }
          }

          // 情况3. 当前播放位置在某段文本对应的时间区间中，返回对应的位置
          const isCurSentence = targetSentence.startTime <= currentTime.value * 1000 && targetSentence.endTime > currentTime.value * 1000
          if(isCurSentence) {
            pIndex = p
            sIndex = s
            break paragraphLoop
          }
        }
      }
    }
  }
  scrollCurrentSentenceIntoView(pIndex, sIndex)
  return [pIndex, sIndex]
})
const paragraphWrapperRef = shallowRef<InstanceType<typeof HTMLDivElement>>()
// 高亮文本隐藏时将高亮内容滚动到可视区域
function scrollCurrentSentenceIntoView (pIndex:number, sIndex:number) {
  const curSentenceDom = document.querySelector(`[data-index="sentence-${pIndex}-${sIndex}"]`)
  const previewWrapper = paragraphWrapperRef.value
  if(curSentenceDom && previewWrapper) {
    const nodeClientRect = curSentenceDom.getBoundingClientRect()
    const wrapperClientRect = previewWrapper.getBoundingClientRect()
    // 高亮文本是否被挡住
    const isHide =
      nodeClientRect.top < wrapperClientRect.top ||
      nodeClientRect.bottom > wrapperClientRect.bottom
    if (isHide) {
      curSentenceDom.scrollIntoView({
        behavior: 'smooth'
      })
    }
  }
}


return { __sfc: true,props, needPlay, handleSetSliderListener, audioRef, audioSrc, playing, currentTime, duration, play, pause, formatSeconds, currentTimeShow, durationTimeShow, curSentence, paragraphWrapperRef, scrollCurrentSentenceIntoView, ContentMain, OverflowTooltip }
}

})